import { render, staticRenderFns } from "./IbSelect.vue?vue&type=template&id=039ecae0"
import script from "./IbSelect.vue?vue&type=script&lang=js"
export * from "./IbSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports